<p-floatlabel variant="on">
  <p-datepicker
    [formControl]="dateFormControl"
    [showIcon]="true"
    [iconDisplay]="'input'"
    [showTime]="true"
    [showButtonBar]="true"
    [dateFormat]="dateFormat"
    hourFormat="24"
    inputId="date_ranges_input"
    appendTo="body"
    inputStyleClass="p-calendar-custom">
  </p-datepicker>
  <label for="date_ranges_input" [addAsteriskIfRequired]="dateFormControl">{{label}}</label>
</p-floatlabel>

